document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ps-newsletter-form') as HTMLFormElement | null
  if (!form) return

  const btn = form.querySelector<HTMLButtonElement>('[type="submit"]')
  const msg = form.querySelector<HTMLElement>('.ps-newsletter__msg')

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    const email   = form.querySelector<HTMLInputElement>('[name="nl_email"]')?.value.trim() ?? ''
    const name    = form.querySelector<HTMLInputElement>('[name="nl_name"]')?.value.trim() ?? ''
    const consent = form.querySelector<HTMLInputElement>('[name="nl_consent"]')?.checked ?? false
    const nonce   = form.querySelector<HTMLInputElement>('[name="nl_nonce"]')?.value ?? ''

    if (!consent) {
      showMsg('Por favor, aceite os termos para continuar.', false)
      return
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Enviando…' }

    try {
      const body = new URLSearchParams({ action: 'ps_newsletter', nl_email: email, nl_name: name, nl_nonce: nonce })
      const res  = await fetch((window as any).siteVars?.ajaxUrl ?? '/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
      const data = await res.json()
      showMsg(data.data?.message ?? (data.success ? 'Inscrição realizada!' : 'Erro. Tente novamente.'), data.success)
      if (data.success) form.reset()
    } catch {
      showMsg('Erro de conexão. Tente novamente.', false)
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Inscrever-se' }
    }
  })

  function showMsg(text: string, success: boolean) {
    if (!msg) return
    msg.textContent = text
    msg.className = 'ps-newsletter__msg mt-3 text-sm font-semibold ' + (success ? 'text-ps-green' : 'text-red')
  }
})
